@import 'src/styles/variabels';

.badge {
  background-color: $color-green;
}
